// Single source of truth for Google Maps JS loader config.
// CRITICAL: every useJsApiLoader call in the app MUST use this exact object
// (same `id`, same `libraries` reference, same key). Otherwise the loader
// gets confused on re-mounts (e.g., navigate away and back) and gets stuck
// at `isLoaded: false`, which disables LocationAutocomplete inputs.

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'mobility-google-maps-loader',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  libraries: ['places'],
};
